// extracted by mini-css-extract-plugin
export var billingAddress = "_qv-g";
export var contactInfo = "_qv-d";
export var customerInfoContainer = "_qv-c";
export var customerInfoContainerMobile = "_qv-h";
export var customerInfoRow = "_qv-a";
export var customerInfoSection = "_qv-b";
export var fullWidthDividerMobile = "_qv-i";
export var imageContainer = "_qv-1";
export var paymentMethod = "_qv-e";
export var priceText = "_qv-6";
export var priceTextMobile = "_qv-7";
export var product = "_qv-0";
export var productImage = "_qv-2";
export var productInfo = "_qv-4";
export var productMobile = "_qv-9";
export var productTitle = "_qv-8";
export var quantityBadge = "_qv-3";
export var quantityText = "_qv-5";
export var shippingAddress = "_qv-f";